import { jsxs as a, jsx as t, Fragment as O } from "react/jsx-runtime";
import { c as n } from "../../../../clsx-OuTLNxxd.js";
import { u as q } from "../../../../downshift.esm-C3e_Yj8x.js";
import { useState as P, useEffect as T, useMemo as A } from "react";
import { I as h } from "../../../../icon-BnqXyiyH.js";
import "../../icon/iconsList.js";
import { AlternativeAction as B } from "./alternativeAction/alternativeAction.js";
const D = "_disabled_52jii_71", G = "_highlight_52jii_147", e = {
  "autocomplete-container": "_autocomplete-container_52jii_29",
  "input-container": "_input-container_52jii_38",
  "has-error": "_has-error_52jii_47",
  "label-helper-text": "_label-helper-text_52jii_50",
  "input-block": "_input-block_52jii_55",
  disabled: D,
  "error-text": "_error-text_52jii_113",
  "suggestions-container": "_suggestions-container_52jii_122",
  "has-alternative-action": "_has-alternative-action_52jii_134",
  "alternative-action-container": "_alternative-action-container_52jii_147",
  highlight: G,
  "item-block": "_item-block_52jii_150",
  "no-suggestion": "_no-suggestion_52jii_161",
  "has-href": "_has-href_52jii_172",
  "alternative-action-container-wrapper": "_alternative-action-container-wrapper_52jii_175"
}, Z = ({
  onChange: _,
  onSelect: p,
  suggestions: r = [],
  inputValue: l,
  noSuggestionText: z,
  placeholder: m,
  label: d,
  labelHelperContent: g,
  inputIcon: f,
  itemsIcon: c,
  disabled: b = !1,
  hasError: u = !1,
  errorText: V,
  alternativeAction: o
}) => {
  const [v, y] = P(l || ""), [j, N] = P(!1), {
    isOpen: I,
    getMenuProps: M,
    getInputProps: R,
    getLabelProps: S,
    getItemProps: x,
    highlightedIndex: w,
    setInputValue: k
  } = q({
    items: r,
    initialInputValue: l,
    onInputValueChange: ({ inputValue: i }) => {
      const s = i || "";
      y(s), _ == null || _(s);
    },
    itemToString: (i) => (i == null ? void 0 : i.value) || "",
    onSelectedItemChange: ({ selectedItem: i }) => {
      i && (p == null || p(i.value));
    }
  });
  T(() => {
    l !== void 0 && k(l);
  }, [l, k]), T(() => {
    if (v && r.length === 0) {
      N(!0);
      const i = setTimeout(() => {
        N(!1);
      }, 500);
      return () => clearTimeout(i);
    }
  }, [v, r]);
  const F = I && (r.length > 0 || j), L = A(
    () => r.map((i, s) => /* @__PURE__ */ a(
      "li",
      {
        className: n(c && e["item-block"], w === s && e.highlight),
        ...x({ item: i, index: s }),
        children: [
          c && /* @__PURE__ */ t(h, { name: c, size: "large" }),
          i.value
        ]
      },
      i.id
    )),
    [r, w, c, x]
  );
  return /* @__PURE__ */ a("div", { className: e["autocomplete-container"], children: [
    /* @__PURE__ */ a("div", { className: e["input-container"], children: [
      d && /* @__PURE__ */ a(O, { children: [
        /* @__PURE__ */ t("label", { className: n(u && e["has-error"]), ...S(), children: d }),
        g && /* @__PURE__ */ t("div", { className: e["label-helper-text"], children: g })
      ] }),
      /* @__PURE__ */ a("div", { className: e["input-block"], children: [
        f && /* @__PURE__ */ t(h, { className: n(b && e.disabled), name: f, size: "large" }),
        /* @__PURE__ */ t(
          "input",
          {
            className: n(u && e["has-error"]),
            type: "text",
            ...m && { placeholder: m },
            ...R({ disabled: b })
          }
        )
      ] }),
      u && /* @__PURE__ */ a("div", { className: e["error-text"], children: [
        /* @__PURE__ */ t(h, { name: "error-warning-fill", size: "large", color: "error" }),
        V
      ] })
    ] }),
    F && /* @__PURE__ */ t("div", { className: n(e["suggestions-container"], o && e["has-alternative-action"]), children: /* @__PURE__ */ a("ul", { ...M(), children: [
      r.length > 0 ? L : j && /* @__PURE__ */ t("li", { className: e["no-suggestion"], children: z }),
      o && /* @__PURE__ */ t(
        "li",
        {
          className: n(e["alternative-action-container"], o.href && e["has-href"]),
          children: /* @__PURE__ */ a("div", { className: e["alternative-action-container-wrapper"], children: [
            /* @__PURE__ */ t(h, { name: "pencil", size: "large", color: "secondary" }),
            /* @__PURE__ */ t(
              B,
              {
                alternativeAction: o.text,
                href: o.href,
                openNewTab: o.openNewTab,
                onAlternativeAction: o.action
              }
            )
          ] })
        }
      )
    ] }) })
  ] });
};
export {
  Z as Autocomplete
};
